import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";

import {
  ChannelThreadId,
  DraftMessageId,
  SupportTicketId,
} from "../ids/definitions";
import { MessageChannel } from "../models/shopper-ai/conversation/message";

const GenerateAiResponseInputBase = Schema.Struct({
  supportTicketId: SupportTicketId,
  threadId: ChannelThreadId,
  channel: MessageChannel,
});

const GenerateAiResponseInputDefault = Schema.Struct({
  ...GenerateAiResponseInputBase.fields,
  mode: Schema.Literal("default", "readonly"),
  customerMessage: Schema.String,
  fileUrls: Schema.optional(Schema.Array(Schema.String)),
  recentCustomerMessages: Schema.optional(Schema.Array(Schema.String)),
});

const GenerateAiResponseInputCopilot = Schema.Struct({
  ...GenerateAiResponseInputBase.fields,
  mode: Schema.Literal("copilot"),
});

export const GenerateAiResponseInput = Schema.Union(
  GenerateAiResponseInputDefault,
  GenerateAiResponseInputCopilot,
);
export type GenerateAiResponseInput = typeof GenerateAiResponseInput.Type;

export const GenerateAiResponseOutput = Schema.Struct({
  threadId: ChannelThreadId,
  status: Schema.Literal("completed"),
  draftId: Schema.optional(DraftMessageId),
});
export type GenerateAiResponseOutput = typeof GenerateAiResponseOutput.Type;

export const AiAgentGroup = HttpApiGroup.make("aiAgent")
  .add(
    endpoint.merchant
      .post("generateAiResponse", "/generate")

      .setPayload(GenerateAiResponseInput)
      .addSuccess(GenerateAiResponseOutput)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api/ai-agent");
